var Marionette = require('backbone.marionette');

var CommonUtils = require('../../utils/common-utils.js');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');

var DocumentActionByDocumentView = Marionette.View.extend({
    template: require('../../templates/documents/document-action-by-document-view.html'),

    regions: {},

    childViewEvents: {},

    ui: {
        action: '#action',
        fileSelector: '#file-input',
        actionTime: '#action-time',
        actionTimeLabel: '#action-time-label'
    },

    events: {
        'change @ui.action': 'onActionChange'
    },

    defaultParameters: {
        time: 0
    },

    parameters: {
        time: 0
    },

    templateContext: function () {
        var that = this;
        return {
        }
    },

    initialize: function (options) {
        this.model = options.model;
        this.canEdit = options.canEdit;
        this.utils = new CommonUtils();
        this.action = 'sign';
    },


    onRender: function () {
        var that = this;
        that.parameters = _.clone(that.defaultParameters);

        that.ui.fileSelector.fileinput({
            uploadLabel: 'Upload for sign',
            uploadUrl: "/api/document/" + that.model.get('id') + "/" + that.action + "/by/document",
            allowedFileExtensions: ["pdf"],
            dropZoneTitle: 'Drag & drop a PDF-file to here &hellip;',
            uploadExtraData: that.parameters
        });

        that.ui.fileSelector.on('fileuploaded', function (event, data, previewId, index) {

            $.notify("The document was "
                + (that.action == 'sign' ? 'signed' : (that.action == 'obsolete' ? 'obsoleted' : ""))
                + " successfully", "success");
            window.setTimeout(function () {
                that.triggerMethod("action:with:document:upload", data.response);
            }, 0);
        });

        that.ui.actionTime.datetimepicker({
            showClear: true,
            showClose: true,
            useCurrent: false,
            format: 'MM/DD/YYYY hh:mm A'
        });
        that.ui.actionTime.on("dp.change", function (e) {

            if (e.date) {
                that.parameters.time = e.date.valueOf();
            } else {
                that.parameters.time = 0;
            }
        }).on('dp.show', function () {
            return $(this).data('DateTimePicker').defaultDate(that.utils.getDateWithoutTime(new Date()));
        });
    },

    onActionChange: function(event) {
        var value = event.target.value;
        this.action = value;
        this.ui.fileSelector.fileinput('refresh', {
            uploadLabel: 'Upload for ' + this.action,
            uploadUrl: "/api/document/" + this.model.get('id') + "/" + this.action + "/by/document"
        });

        if (value === "sign") {
            this.ui.actionTimeLabel.text("Signature date:");
        } else if (value == "obsolete") {
            this.ui.actionTimeLabel.text("Obsoleted date:");
        }
    }
});

module.exports = DocumentActionByDocumentView;


//////////////////
// WEBPACK FOOTER
// ./app/views/documents/document-action-by-document-view.js
// module id = 421
// module chunks = 0